import { Link } from 'react-router-dom';
import ScrollReveal from '../../../components/ui/ScrollReveal';

const services = [
  {
    num: '01',
    title: '1-2-1 Personal Training',
    tag: 'In-Person · London',
    desc: 'Dedicated one-on-one sessions built entirely around your goals. Expert coaching, progressive programming, and the accountability that delivers real, lasting change.',
    to: '/personal-training',
    // Use image that shows Laura full frame, position top so face is visible
    img: '/images/Laura_5.png',
    pos: 'object-top',
  },
  {
    num: '02',
    title: 'Bespoke Online Coaching',
    tag: 'Remote · Worldwide',
    desc: 'Your personal trainer in your pocket. Fully customised programmes delivered through a dedicated app, with weekly check-ins and direct access to Laura.',
    to: '/online-training',
    img: '/images/online-coaching.jpg',
    pos: 'object-[50%_15%]',
  },
  {
    num: '03',
    title: 'Nutritional Coaching',
    tag: 'Remote · Worldwide',
    desc: 'Fuel your transformation from the inside out. Personalised nutrition plans built around your lifestyle — no fad diets, just sustainable habits that actually work.',
    to: '/nutritional-coaching',
    img: '/images/nutrition.jpg',
    pos: 'object-[50%_15%]',
  },
];

export default function MethodsSection() {
  return (
    <section className="bg-stone-100 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <ScrollReveal>
            <div className="flex items-center gap-4 mb-5">
              <span className="w-8 h-px bg-[#c9a96e]" />
              <span className="text-[#c9a96e] text-[10px] font-sans font-semibold tracking-[0.32em] uppercase">Services</span>
            </div>
            <h2
              className="text-stone-900"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2.4rem, 5vw, 4rem)', fontWeight: 600, lineHeight: 1.05 }}
            >
              Three Pathways
              <br />
              <em className="text-[#c9a96e] not-italic">To Your Best Self.</em>
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={150}>
            <p className="text-stone-500 font-sans text-sm leading-relaxed max-w-xs">
              Choose one service or combine them for a complete transformation programme.
            </p>
          </ScrollReveal>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <ScrollReveal key={s.num} delay={i * 100}>
              <Link
                to={s.to}
                className="group block bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:shadow-stone-200 transition-all duration-500 border border-stone-100"
              >
                {/* Image — taller crop, face positioned at top */}
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={s.img}
                    alt={`${s.title} with Laura Martin personal trainer London`}
                    loading="lazy"
                    className={`w-full h-full object-cover ${s.pos} transition-transform duration-700 group-hover:scale-105`}
                  />
                  {/* Lighter overlay so face is visible */}
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-60" />

                  <span
                    className="absolute top-4 left-4 text-stone-900/8 font-display font-bold text-5xl group-hover:text-[#c9a96e]/12 transition-colors duration-300"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {s.num}
                  </span>
                  <span className="absolute top-4 right-4 px-3 py-1 bg-white/80 backdrop-blur-sm text-stone-600 text-[9px] font-sans tracking-widest uppercase rounded-full border border-stone-200">
                    {s.tag}
                  </span>
                </div>

                {/* Content */}
                <div className="p-7">
                  <h3
                    className="text-stone-900 text-xl mb-3 font-semibold group-hover:text-[#c9a96e] transition-colors duration-300"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {s.title}
                  </h3>
                  <p className="text-stone-500 font-sans text-sm leading-relaxed mb-7">{s.desc}</p>
                  <span className="inline-flex items-center gap-2 text-[#c9a96e] text-[10px] font-sans font-bold tracking-[0.25em] uppercase">
                    Find Out More
                    <span className="w-6 h-6 rounded-full border border-[#c9a96e]/40 flex items-center justify-center group-hover:bg-[#c9a96e] group-hover:border-[#c9a96e] transition-all duration-300">
                      <i className="ri-arrow-right-line text-xs group-hover:text-white" />
                    </span>
                  </span>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
